module.exports = __webpack_public_path__ + "img/bamboo.be5030ca.webp";